import React, {useEffect} from "react";
import {Route, Routes, useNavigate} from "react-router-dom";
import Login from "../../onboarding/pages/Login";
import PlatformApp from "./PlatformApp";
import {Loading} from "./Loading";
import {
    buildUrl,
    FORGOT_PASSWORD_EMAIL,
    FORGOT_PASSWORD_RESET,
    LOADING,
    LOGIN,
    NO_CADDIE_MASTERS,
    PLATFORM_HOME,
    REGISTER_CREATE_PROFILE,
    REGISTER_CREDENTIALS,
    REGISTER_EMAIL_CONFIRM
} from "../../../services/PageUtils";
import {useDispatch} from "react-redux";
import {AppDispatch, startAppListening} from "../../../services/store/store";
import {Unsubscribe} from "@reduxjs/toolkit";
import {setupClubListeners} from "../../../services/store/reducers/clubs/listeners";
import useColourScheme from "../../../hooks/useColourScheme";
import {setupReviewListeners} from "../../../services/store/reducers/reviews/listeners";
import ResetPassword from "../../onboarding/pages/ResetPassword";
import ForgotPasswordEmailConfirmation from "../../onboarding/pages/ForgotPasswordEmailConfirmation";
import RegisterCredentials from "../../onboarding/pages/RegisterCredentials";
import RegisterEmailConfirm from "../../onboarding/pages/RegisterEmailConfirm";
import RegisterCreateProfile from "../../onboarding/pages/RegisterCreateProfile";
import {refreshSession} from "../../../services/store/reducers/session/asyncActions";
import {handicaddieSelector} from "../../../services/store/asyncThunk";
import {handleLogOut, SessionState} from "../../../services/store/reducers/session/slice";
import {setupSessionListeners} from "../../../services/store/reducers/session/listeners";
import {NoCaddieMasters} from "../../onboarding/pages/NoCaddieMasters";

const App = () => {

    const navigate = useNavigate();

    // this is required to initialise the theming!
    useColourScheme();

    const dispatch = useDispatch<AppDispatch>();
    const { sessionState } = handicaddieSelector(state => state.session)

    useEffect(() => {
        dispatch(refreshSession())
    }, [])

    useEffect(() => {
        const subscriptions: Unsubscribe[] = [
            setupClubListeners(startAppListening),
            setupReviewListeners(startAppListening),
            setupSessionListeners(startAppListening),
        ]

        return () => subscriptions.forEach((unsubscribe) => unsubscribe())
    }, [])

    useEffect(() => {
        switch (sessionState) {
            case SessionState.LOADING:
                return;
            case SessionState.REGISTERING_RESETTING:
                return;
            case SessionState.INACTIVE:
                navigate(LOGIN);
                return;
            case SessionState.NO_PROFILE:
                navigate(REGISTER_CREATE_PROFILE);
                return;
            case SessionState.NO_CADDIE_MASTERS:
                navigate(NO_CADDIE_MASTERS);
                return;
            default:
                navigate(buildUrl(PLATFORM_HOME));
                return;
        }
    }, [sessionState]);

    const logOut = () => {
        dispatch(handleLogOut())
        navigate(LOGIN)
    }

    return (
        <div style={{height: "100%"}}>
            <Routes>
                <Route path={LOGIN} element={<Login />} />
                <Route path={LOADING} element={<Loading />}/>
                <Route path={FORGOT_PASSWORD_EMAIL} element={<ForgotPasswordEmailConfirmation />}/>
                <Route path={FORGOT_PASSWORD_RESET} element={<ResetPassword />} />
                <Route path={REGISTER_CREDENTIALS} element={<RegisterCredentials />} />
                <Route path={REGISTER_EMAIL_CONFIRM} element={<RegisterEmailConfirm />} />
                <Route path={REGISTER_CREATE_PROFILE} element={<RegisterCreateProfile />} />
                <Route path={NO_CADDIE_MASTERS} element={<NoCaddieMasters />} />
                <Route path="/platform/*" element={<PlatformApp logOut={logOut} />} />
                <Route index element={<PlatformApp logOut={logOut} />} />
            </Routes>
        </div>
    );
};

export default App;
